import * as gtxTool from "../gtx/gtx";
import * as logger from "../logger";
import { dumpGtv } from "./dump";
/**
 * Decodes the transaction using ASN.1.
 * @returns the transaction decoded in GTX format
 */
export function decodeTransactionToGtx(encodedTransaction) {
    const gtx = gtxTool.deserialize(encodedTransaction);
    logger.debug(`Output from deserializing a raw transaction: ${dumpGtv(gtx)}`);
    return gtx;
}
//# sourceMappingURL=decodeTransactionToGtx.js.map